/*
 * @Description:
 * @Author: shufei
 * @Date: 2021-11-20 13:09:47
 * @LastEditTime: 2021-11-21 00:18:16
 * @LastEditors: shufei
 */
import Cookies from 'js-cookie'
import axios from 'axios'
import store from '@/store'
import wx from 'weixin-js-sdk'
import { addPendingRequest, removePendingRequest, loading, errorHandle } from './utils'
axios.defaults.headers = {
  // 'Content-Type': 'application/x-www-form-urlencoded',
  withCredentials: true
}
// 创建axios实例
// console.log('process.env.NODE_ENV', process.env.NODE_ENV, process.env.VUE_APP_BASE_API)
const instance = axios.create({
  baseURL: '/api',
  timeout: 1000 * 10,
  withCredentials: true
  // cancelToken: source.token // 取消请求（比如你进入某个路由后，可能就停在了这个页面就1s时间， 就立马进入了下个路由，这时，前边这个路由的请求就可以取消掉了）
})

instance.interceptors.request.use(
  function (config) {
    // 重复请求校验
    removePendingRequest(config) // 检查是否存在重复请求，若存在则取消已发的请求
    addPendingRequest(config) // 把当前请求添加到pendingRequest对象中
    // 如果是 非登录页面 ，对携带 token 须校验
    if (config.url !== '/login') {
      const token = localStorage.getItem('token')
      // 请求头携带token
      token && (config.headers.Authorization = token)
    }
    config.showLoading && loading.open()
    // const token = store.state.page.token
    const token = Cookies.get('bcssToken')
    if (token && token !== 'undefined') config.headers.Authorization = token
    // token && (config.headers.Authorization = token)

    // 埋点
    // axios
    //   .get(
    //     `https://vticket.yuuwei.com/shannon.gif?bcssToken=${Cookies.get('bcssToken')}&userId=${Cookies.get(
    //       'userid'
    //     )}&requestUrl=${config.url}&version=1.1.0&currentUrl=${encodeURIComponent(window.location.href)}`
    //   )
    //   .catch(err => {
    //     console.error('日志记录失败', err)
    //   })

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    // console.log(response, 'response')
    // const state = response.status
    // console.log('state', state)
    // if (state == 401) {
    //   console.log('state', state)
    //   Cookies.remove('bcssToken')
    //   Cookies.remove('userId')
    //   const path = `/pages/bcssLogin/login?callbackUrl=${encodeURIComponent(window.location.href)}`
    //   wx.miniProgram.navigateTo({
    //     url: path
    //   })
    //   return // 阻止继续执行
    // }
    response.config.showLoading && loading.close()
    removePendingRequest(response.config) // 从pendingRequest对象中移除请求
    return response
  },
  error => {
    // console.log(error, 'Error!!!!!!!')
    if (error.message.includes('401') || error.response.status === 401 || error.message.includes('重新登陆')) {
      console.log(error.message, 'error')

      const callbackUrl = window.location.href
      if (callbackUrl.includes('miniT')) {
        // 防止链接中存在多个miniT参数,若存在则将其去除，往小程序送的链接中不应该存在miniT参数
        const params = new URL(window.location.href).searchParams
        const miniT = params.get('miniT').replaceAll(' ', '+')
        // const miniT = callbackUrl.split('?miniT=')[1].split('#/')[0]
        const callbackUrlNew = callbackUrl.replace(`miniT=${miniT}`, '')
        const path = `/pages/bcssLogin/login?isClear=true&callbackUrl=${encodeURIComponent(callbackUrlNew)}`
        axios
          .get(`https://vticket.yuuwei.com/shannon.gif?version=1.1.0&status=401`)
          .then(() => {
            wx.miniProgram.navigateTo({
              url: path
            })
          })
          .catch(err => {
            console.error('日志记录失败', err)
          })
      } else {
        // 不存在则直接将当前页面链接传递给小程序
        const path = `/pages/bcssLogin/login?isClear=true&callbackUrl=${encodeURIComponent(callbackUrl)}`
        axios
          .get(`https://vticket.yuuwei.com/shannon.gif?version=1.1.0&status=401`)
          .then(() => {
            wx.miniProgram.navigateTo({
              url: path
            })
          })
          .catch(err => {
            console.error('日志记录失败', err)
          })
      }
    }
    removePendingRequest(error.config || {}) // 从pendingRequest对象中移除请求
    if (instance.isCancel(error)) {
      console.log('已取消的重复请求：' + error.message)
    } else {
      // 添加异常处理
    }
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        store.commit('changeNetwork', false)
      } else {
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)

export default instance
